module.exports = __webpack_public_path__ + "fonts/DINNextLTW23-Regular.be10c1c1.woff2";